// extracted by mini-css-extract-plugin
export default {"addToastBtn":"ToastPad_addToastBtn__8EK2X","toast":"ToastPad_toast__fuPtF"};